import type React from 'react';
import sangomaLogo from '~/static/assets/logos/headerLogo.png';

export const PageHeader: React.FC<{ titleId: string }> = ({ titleId }) => (
  <>
    <img
      src={sangomaLogo.src}
      width={sangomaLogo.width}
      height={sangomaLogo.height}
      alt="Sangoma"
      className="mobile-app-redirect__logo"
    />

    <h1 id={titleId} className="mobile-app-redirect__title">
      Join Your Meeting
    </h1>
    <p className="mobile-app-redirect__description">
      To join using the app, you'll need to sign in with your account first.
    </p>
  </>
);
